// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-events-tsx": () => import("./../../../src/templates/Events.tsx" /* webpackChunkName: "component---src-templates-events-tsx" */),
  "component---src-templates-pages-tsx": () => import("./../../../src/templates/Pages.tsx" /* webpackChunkName: "component---src-templates-pages-tsx" */)
}

